export default {"src":"/_next/static/media/bone_24.ec514f87.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};